export default angular.module("khUtils", ["kh.accordion"]);